"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAddressHelpers = exports.StaticAddressHelpers = void 0;
const COMMA_SEPARATOR = ', ';
class StaticAddressHelpers {
    static validateAddress(address) {
        return Boolean(address);
    }
    static formatAddress(addressDetails) {
        const { additionalInfo, city, postalCode, number, street, province, countryCode } = addressDetails;
        return [
            [street, number, additionalInfo].filter(Boolean).join(COMMA_SEPARATOR).trim(),
            [city, province, postalCode, countryCode].filter(Boolean).join(COMMA_SEPARATOR).trim(),
        ].filter(Boolean);
    }
}
exports.StaticAddressHelpers = StaticAddressHelpers;
class DefaultAddressHelpers extends StaticAddressHelpers {
    validateAddress(address) {
        return DefaultAddressHelpers.validateAddress(address);
    }
    formatAddress(address) {
        return DefaultAddressHelpers.formatAddress(address);
    }
}
exports.DefaultAddressHelpers = DefaultAddressHelpers;
//# sourceMappingURL=DefaultAddressHelpers.js.map